import { BaseModel } from "./baseModel";

export enum PermissionResources {
    "WORKSPACE" = "WORKSPACE",
    "BOT" = "BOT",
    "ENTITY" = "ENTITY",
    "USER" = "USER",
    "ORGANIZATION" = "ORGANIZATION",
    "ANY" = "ANY",
}
export enum UserRoles {
    'WORKSPACE_ADMIN' = 'WORKSPACE_ADMIN',
    'WORKSPACE_AGENT' = 'WORKSPACE_AGENT',
    'WORKSPACE_INACTIVE' = 'WORKSPACE_INACTIVE',
    'DASHBOARD_ADMIN' = 'DASHBOARD_ADMIN', // Role especifica para que agentes consigam acessar dashboards
    'WORKSPACE_PENDENT_CONFIG' = 'WORKSPACE_PENDENT_CONFIG',
    'BOT_DEVELOP' = 'BOT_DEVELOP',
    'BOT_ADMIN' = 'BOT_ADMIN',
    'USER_ADMIN' = 'USER_ADMIN',
    'ORGANIZATION_ADMIN' = 'ORGANIZATION_ADMIN',
    'QUEUE_ADMIN' = 'QUEUE_ADMIN',
    'SYSTEM_ADMIN' = 'SYSTEM_ADMIN',
    'SYSTEM_CS_ADMIN' = 'SYSTEM_CS_ADMIN',
    'SYSTEM_UX_ADMIN' = 'SYSTEM_UX_ADMIN',
    'SYSTEM_DEV_ADMIN' = 'SYSTEM_DEV_ADMIN',
    'SYSTEM_FARMER_ADMIN' = 'SYSTEM_FARMER_ADMIN',
}

export interface Role extends BaseModel {
    resource: PermissionResources,
    resourceId?: String,
    role: UserRoles
}

export interface UserRoleResource extends BaseModel {
    resourceId: string,
    resourceName: string,
    resourceType: PermissionResources
}


export enum UserLanguage {
    pt = "pt",
    en = "en",
    es = "es"
}

export enum LoginMethod {
    dasa = 'dasa',
    bot = 'bot',
}
export interface User extends BaseModel{
  name: string;
  email: string;
  cognitoUniqueId?: string;
  password: string;
  rememberPasswordToken?: string;
  rememberPasswordTokenExpiration?: Date;
  roles?: Array<Role>;
  language: UserLanguage;
  liveAgentParams?: LiveAgentParams;
  passwordExpires?: number;
  avatar?: string;
  timezone?: string;
}

export interface LiveAgentParams {
    notifications?: {
        emitSoundNotifications?: boolean;
        notificationNewAttendance?: boolean;
    }
}
